export class FeedbackDevice {
  public constructor() {
    this.FeedbackCode = "";
    this.Series = "";
    this.Model = "";
    this.FeedbackTypeRowPointer = "";
    this.MeasuringType = "";
    this.TurnType = "";
    this.Resolution = 0.0;
    this.MinSupplyVoltage = 0.0;
    this.MaxSupplyVoltage = 0.0;
    this.MinTemp = 0.0;
    this.MaxTemp = 0.0;
    this.PolePairs = 0;
    this.ExcitationFreq = 0.0;
    this.TransRatio = 0.0;
    this.PhaseShift = 0.0;
    this.ThermalConnection = false;
    this.PPRorLPR = 0.0;
    this.MTResolution = 0.0;
    this.RowPointer = "";
    this.Manufacturer = "";
  }


 
  public FeedbackCode: string;
  public Manufacturer: string;
  public Series: string;

  public Model: string;

  public FeedbackTypeRowPointer: string;

  public MeasuringType: string;
  public TurnType: string;
  public Resolution: number;
  public MinSupplyVoltage: number;
  public MaxSupplyVoltage: number;
  public MinTemp: number;
  public MaxTemp: number;
  public PolePairs: number;
  public ExcitationFreq: number;
  public TransRatio: number;
  public PhaseShift: number;
  public ThermalConnection: boolean;
  public PPRorLPR: number;
  public MTResolution: number;  
  public RowPointer: string;
  
}
